import { Star } from "lucide-react";

const ITEMS = ["Seasonal ingredients", "12 months", "12 places", "Bold illustration", "When, where & what to eat"];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="relative z-20 -mx-2 -mt-10 -rotate-1 overflow-hidden border-y-4 border-navy bg-navy py-4 md:py-5"
    >
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-display text-lg font-extrabold uppercase tracking-wide text-banana md:px-10 md:text-2xl">
                  {item}
                </span>
                <Star className="h-5 w-5 shrink-0 fill-punch text-punch md:h-6 md:w-6" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
